export const TKeyMcp = {
  MCP_CONSENT_TITLE: "MCP_CONSENT_TITLE",
  MCP_CONSENT_DESC: "MCP_CONSENT_DESC",
  MCP_CONSENT_LOGIN_REQUIRED: "MCP_CONSENT_LOGIN_REQUIRED",
  MCP_CONSENT_LOGIN_BUTTON: "MCP_CONSENT_LOGIN_BUTTON",
  MCP_CONSENT_AUTHORIZE: "MCP_CONSENT_AUTHORIZE",
  MCP_CONSENT_DENY: "MCP_CONSENT_DENY",
  MCP_CONSENT_ERROR: "MCP_CONSENT_ERROR",
  MCP_CONSENT_INVALID: "MCP_CONSENT_INVALID",
} as const;
